import React from "react";

import { AppLayout } from "@src/components/app_layout";
import { ErrorBoundary } from "@src/components/error_boundary";
import { ROUTES } from "@src/constants";
import { AdminProjectAssignmentsPage } from "@src/pages/admin/admin_project_assignments_page";
import { AdminRoleAssignmentPage } from "@src/pages/admin/admin_role_assignment_page";
import { EmployeeDataPage } from "@src/pages/admin/employee_data_page";
import { RegionAssignmentPage } from "@src/pages/admin/region_assignment_page";
import { RoleAssignmentPage } from "@src/pages/admin/role_assignment_page";
import { SapCsvUploadPage } from "@src/pages/admin/sap_csv_upload_page";
import { CreateProjectPage } from "@src/pages/create_project_page";
import { DashBoardPage } from "@src/pages/dashboard";
import { ProjectPage } from "@src/pages/project_page";
import { ProjectsOverviewPage } from "@src/pages/projects_overview_page";
import { StaffingRequestOverviewPage } from "@src/pages/staffing_requests_overview_page";
import { StartScreenPage } from "@src/pages/start_screen_page";
import { TeamMemberOverviewPage } from "@src/pages/team_member_overview_page";
import {
  Navigate,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

const Router: React.FC = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <AppLayout />,
      errorElement: <ErrorBoundary />,
      children: [
        {
          path: `${ROUTES.PROJECT_LEAD.PROJECTS_CREATE}/:id?`,
          element: <CreateProjectPage />,
        },
        {
          path: `${ROUTES.PROJECT_LEAD.PROJECTS}/:id`,
          element: <ProjectPage />,
        },
        {
          path: ROUTES.PROJECT_LEAD.PROJECTS,
          element: <ProjectsOverviewPage />,
        },
        {
          path: ROUTES.ADMIN.REGION_ASSIGNMENT,
          element: <RegionAssignmentPage />,
        },
        {
          path: ROUTES.MANAGER.DASHBOARD,
          element: <DashBoardPage />,
        },
        {
          path: ROUTES.ADMIN.ROLE_ASSIGNMENT_V2,
          element: <RoleAssignmentPage />,
        },
        {
          path: ROUTES.ADMIN.ROLE_ASSIGNMENT,
          element: <AdminRoleAssignmentPage />,
        },
        {
          path: ROUTES.ADMIN.PROJECT_ASSIGNMENTS,
          element: <AdminProjectAssignmentsPage />,
        },
        {
          path: ROUTES.ADMIN.EMPLOYEE_DATA,
          element: <EmployeeDataPage />,
        },
        {
          path: ROUTES.ADMIN.SAP,
          element: <SapCsvUploadPage />,
        },
        {
          path: ROUTES.TEAM_LEAD.STAFFING_REQUESTS,
          element: <StaffingRequestOverviewPage />,
        },
        {
          path: ROUTES.TEAM_LEAD.TEAM_OVERVIEW,
          element: <TeamMemberOverviewPage />,
        },
        {
          path: "/",
          element: <StartScreenPage />,
        },
        {
          path: "*",
          element: <Navigate to="/" replace />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};

export default Router;
